import { useContext } from "react";
import RouteContext from "./contexts/routeContext";
import RouterContext from "./contexts/routerContext";
import QueryRouter from "./QueryRouter";
import Route from "./Route";
import { RouterLink } from "./RouterLink";
import Routes from "./Routes";

const useQueryRouter = () => useContext(RouterContext);
const useRouteParams = () => useContext(RouteContext);

export {
	QueryRouter,
	Route,
	RouterLink,
	Routes,
	useQueryRouter,
	useRouteParams,
};
